import { render, staticRenderFns } from "./community.vue?vue&type=template&id=686e73e0&scoped=true&"
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"
import style0 from "./community.vue?vue&type=style&index=0&id=686e73e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e73e0",
  null
  
)

export default component.exports